<template lang="pug">
  section(class="separable" v-if="dadosVtn")
    app-modal-termo-compromisso(
      v-if="showModal"
      @closeModal="()=> showModal = false"
      @aceitarTermo="aceitarTermo"
      :isTermoAceito="isTermoAceito"
      :tipoPagamento="tipoPagamento"
      @setTermo="setTermo"
    )
    div(class="container")
      el-row
        el-col(:span="24")
          div(class="card margin10")
            div(class="card-body")
              app-dados-calculo-vtn(:tipoProcesso="tipoProcesso")
              app-divider(label="Forma de pagamento:").margin10
              div(class="card-body")
                div(class="aling-center")
                  validation-provider(rules="required", v-slot="{ errors }")
                    el-radio-group(v-model="tipoPagamento", :disabled="bloqueiaCheack()" @change="setRadio", :class="{'error-radio' : errors.length}" )
                      el-radio(v-if="!excedente" label="PARCELADO" @change="calcularValor" ) Pagamento parcelado
                      el-radio(label="A_VISTA"  @change="calcularValor") Pagamento à vista
                    span.help.erro {{ errors[0] }}

                div(v-if="tipoPagamento === 'PARCELADO'")
                  div.row
                    validation-provider(v-if="!excedente", rules="required", v-slot="{ errors }")
                      app-label(
                        label="Parcelas: ",
                        :required="true"
                      )
                      el-input-number.input(
                        type="number",
                        size="small"
                        :min="2"
                        :default="10"
                        :max="10"
                        :disabled="dadosVtn.isFinalizado"
                        v-model="parcelas"
                        name="parcelas",
                        v-mask="['##']",
                        @change="calcularValor"
                      )
                      span.help.erro {{ errors[0] }}

                    validation-provider(v-if="!excedente", rules="required", v-slot="{ errors }")
                      app-label(
                        label="Entrada: ",
                        :required="true"
                      )
                      el-input-number.input(
                        type="number",
                        size="small"
                        :min="10"
                        :max="99"
                        v-mask="['##']",
                        :disabled="dadosVtn.isFinalizado"
                        v-model="entrada"
                        name="entrada",
                        @change="calcularValor"
                      )
                      span.suffix-element %
                      span.help.erro {{ errors[0] }}
                  div
                    app-resumo-parcelas-vtn(:formaPagamento="tipoPagamento", :tipoProcesso="tipoProcesso")
                div(v-else)
                  app-resumo-parcelas-vtn(:formaPagamento="tipoPagamento", :tipoProcesso="tipoProcesso")
        app-buttons-cadastro(
          :isUltimoPasso="true",
          :isPrimeiroPasso="true",
          @finalizar="finalizar",
          :showButtonFinalizar="showBotaoFinalizar && !dadosVtn.isFinalizado"
          @cancelar="cancelar"
        )
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppDadosCalculoVtn from '@/components/AppDadosCalculoVtn'
import AppLabel from '@/components/AppLabel'
import AppModalTermoCompromisso from '@/components/AppModalTermoCompromissoVtn'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumoParcelasVtn from '@/components/AppResumoParcelasVtn'
import utils from '@/utils/utils'
import axios from '@/utils/api'
import { mapActions } from 'vuex'

export default {
  components: {
    AppDisplay,
    AppDivider,
    AppLabel,
    AppResumoParcelasVtn,
    AppButtonsCadastro,
    AppModalTermoCompromisso,
    AppDadosCalculoVtn
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idVtn: {
      required: true
    },
    showBotaoFinalizar: {
      required: false,
      default: true
    }
  },

  data () {
    return {
      isTermoAceito: false,
      tipoPagamento: 'PARCELADO',
      parcelas: 10,
      entrada: 10,
      dadosVtn: null,
      showModal: false,
      excedente: false,
      textoIfd: `
        Caso o número de módulos fiscais seja menor ou igual a um, ou maior ou igual a quinze, IFd = 1,17.\n
        Caso não se enquadre em nenhuma das condições anteriores, o IFd = 0,0571 * Número de Módulos Fiscais + 0,3129.`
    }
  },

  computed: {
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    processo: {
      get () {
        return this.$store.getters['processos/processo']
      }
    },
    tipoProcesso: {
      get () {
        if (this.processo && this.processo.tipo && this.processo.tipo.codigo) {
          return this.processo.tipo.codigo
        } else if (this.processo && this.processo.tipo) {
          return this.processo.tipo
        }
        return '-'
      }
    }
  },

  methods: {
    ...mapActions({
      findDaes: 'dae/findDaesByNumeroProcesso'
    }),
    setRadio (tipo) {
      this.tipoPagamento = tipo
    },
    setTermo (value) {
      this.isTermoAceito = value
    },
    formatTotal (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },
    async calcularValor () {
      this.dadosVtn.formaPagamento = this.tipoPagamento
      if (this.tipoPagamento === 'PARCELADO') {
        this.dadosVtn.quantidadeParcelas = this.parcelas
        this.dadosVtn.valorEntrada = this.entrada
      } else {
        this.dadosVtn.quantidadeParcelas = null
        this.dadosVtn.valorEntrada = null
      }

      this.dadosVtn.numeroProcesso = this.dadosVtn.processoSicarf.numeroProcesso
      this.dadosVtn = await axios({
        method: 'POST',
        url: `financeiro/vtn/preview`,
        data: this.dadosVtn
      })
      this.$store.commit('vtn/SET_VTN', { ...this.dadosVtn })
    },
    montarVtn () {
      this.parcelas = this.dadosVtn.quantidadeParcelas
      this.entrada = this.dadosVtn.valorEntrada
      if (this.processo.tipo) {
        this.tipoPagamento = this.verificarTipoPagamento()
      } else {
        this.cancelar()
      }
    },
    verificarTipoPagamento () {
      if (this.processo?.tipo?.codigo === 'ONEROSO' || this.processo?.tipoCodigo === 'ONEROSO') {
        return this.dadosVtn?.formaPagamento === null ? '' : this.dadosVtn?.formaPagamento
      }
      this.dadosVtn.formaPagamento = 'A_VISTA'
      return 'A_VISTA'
    },
    cancelar () {
      this.$router.back()
    },
    async aceitarTermo () {
      axios({
        method: 'POST',
        url: `financeiro/vtn`,
        data: { ...this.dadosVtn, numeroProcesso: this.dadosVtn.processoSicarf.numeroProcesso }
      }).then(() => {
        axios({
          method: 'PUT',
          url: `financeiro/vtn/finalizar/${this.idVtn}`
        }).then(() => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
          this.$router.push({
            name: 'gerenciamento-daes'
          })
        }).catch((error) => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
        })
      })
    },
    finalizar () {
      this.showModal = true
    },

    bloqueiaCheack () {
      return this.processo?.tipo?.codigo !== 'ONEROSO' || this.dadosVtn.isFinalizado
    },

    async tratarVtn () {
      if (this.$route.params.excedente) {
        this.excedente = this.$route.params.excedente
      }

      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/getParcelaExcedenteByIdVtn/${this.idVtn}`,
        params: {
          excedente: this.excedente
        }
      })

      if (this.dadosVtn) {
        if (!this.dadosVtn.isFinalizado) {
          this.dadosVtn.quantidadeParcelas = this.parcelas
          this.dadosVtn.valorEntrada = this.entrada
        }

        if (this.excedente) {
          await axios({
            method: 'POST',
            url: `financeiro/vtn/tramitarVtnExcedente/${this.idVtn}`
          })
        }
      }
      this.$store.commit('vtn/SET_VTN', { ...this.dadosVtn })
      this.montarVtn()
    }
  },

  async created () {
    await this.tratarVtn()
  }
}
</script>

<style lang="scss" scoped>
  .conteudo {
    margin: 0px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .dataLimite {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .card {
    margin-top: 0;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .aling-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }

  .margin10 {
    margin: 10px;
  }

  .card .card-header {
    font-size: x-large;
    line-height: initial;
    padding: 23px 23px 0 23px;
  }

  .suffix-element {
    position: absolute;
    z-index: 999;
    margin-top: 10px;
    margin-left: -56px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/vtn/AppCalculoVtn.vue